import { createFileRoute, redirect } from '@tanstack/react-router';

import { getResearchPerfEvalsOptions } from '@/module/ResearchPerfEval/model/ResearchPerfEvalQuery';

import { NoContentPlaceholder } from '@/core/components';

export const Route = createFileRoute('/_auth/research-perf-eval/_layout/')({
  loader: async ({ context: { queryClient } }) => {
    const data = await queryClient.ensureQueryData(getResearchPerfEvalsOptions());
    if (data.length > 0) {
      throw redirect({ to: String(data[0].id) });
    }
  },
  component: () => <NoContentPlaceholder title="Selectați anul raportării din partea stângă" />,
});
